import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { PostHogProvider } from "posthog-js/react";

import { ErrorScreen } from "~/components/error-screen";
import { NotFoundScreen } from "~/components/not-found-screen";
import { orpc } from "~/lib/orpc";
import { posthogKey, posthogClient } from "~/observability/posthog";
import { routeTree } from "./routeTree.gen";

export function getRouter() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient, orpc },
    defaultPreload: "intent",
    defaultErrorComponent: ErrorScreen,
    defaultNotFoundComponent: NotFoundScreen,
    Wrap: function WrapComponent({ children }) {
      const key = posthogKey();
      const inner = (
        <QueryClientProvider client={queryClient}>
          {children}
        </QueryClientProvider>
      );
      return key ? (
        <PostHogProvider client={posthogClient}>{inner}</PostHogProvider>
      ) : (
        inner
      );
    },
  });

  return router;
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
